// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"488": "fd6d53fed0a4054e","757": "344de2a755e65cf5",}[chunkId] + ".css"
}